import Vue from 'vue';
import firebase from "../../firebase";

// initial state
const state = {
  counter: 0
};

const getters = {
  counter: function(state) {
    return state.counter;
  }
};

const mutations = {
  setCounter: function(state, counter) {
    state.counter = counter;
  }
};

const actions = {
  getCounterByCampaignId: function(context, campaignId) {
    firebase.database
      .ref("campaigns")
      .child(campaignId)
      .child("count")
      .on("value", function(snapshot) {
        context.commit("setCounter", snapshot.val());
      });
  },
  getContentMessageById: function(context, id) {
    return firebase.database.ref('content-messages').child(id).once("value")
      .then((snapshot) => snapshot.val())
      .catch((err) => {
          console.error(err);
      });
  },
  saveLead: function(context, data) {
    return new Promise((resolve, reject) => {
      var date = new Date();
      data.lead.createdDate = date.toISOString();
      firebase.database
        .ref("leads")
        .child(data.campaignId)
        .push(data.lead, function(error) {
          if (error) {
            console.log("Error has occured during saving process", error);
            reject(error);
          } else {
            console.log("saveLead success");
            resolve();
          }
        });
    });
  },
  savePartnershipForm: function(context, data) {
    return new Promise((resolve, reject) => {
      var date = new Date();
      data.lead.createdDate = date.toISOString();
      firebase.database
        .ref("partnershipform")
        .push(data.lead, function(error) {
          if (error) {
            console.log("Error has occured during saving process", error);
            reject(error);
          } else {
            console.log("savePartnershipForm success");
            resolve();
          }
        });
    });
  },
  checkEmail: function (context, data) {
    if (!data.email || data.email.length === 0 || !data.email.includes('@')) {
      return false;
    }
    
    // Check if the mail already exist for this particular campaign
    return Vue.http.post(`${wwfconfigs.CLOUDFUNCTION}/checkEmailForCampaign?campaignId=${data.campaignId}&email=${data.email}`)
      .then(response => {
        return response.body.exist;
      }, 
        error => {
          console.error(error);
          return false;
        }
      );
  },
  getEPBCRecipients: function (context, data) {
    return Vue.http.post(`${wwfconfigs.CLOUDFUNCTION}/epbcGetRecipients?postcode=${data.postcode}`)
      .then(response => {
        return response.body;
      }, 
        error => {
          console.error(error);
          return false;
        }
      );
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/campaign.js